module.exports = __webpack_public_path__ + "static/media/maintenance_page_2x.30747459.png";